
import { Fraga } from "@/types/riskbedomning";
import { getFollowUpQuestionsForCategory } from "./followUpQuestions";

export const fragorData: Fraga[] = [
  // Arbetsmiljörisker
  {
    id: "arbetsmiljo_1",
    text: "Finns det risker inom arbetsmiljöområdet som kan påverka personalens hälsa och säkerhet?",
    kategori: "Arbetsmiljö",
    fas: "byggskede",
    followUpQuestions: getFollowUpQuestionsForCategory("arbetsmiljo_1"),
    afsReferences: ["AFS 2023:1", "AFS 2023:2"]
  },
  {
    id: "arbetsmiljo_2", 
    text: "Kan arbetsmiljön påverkas negativt av nya processer eller förändringar i verksamheten?",
    kategori: "Arbetsmiljö",
    fas: "byggskede",
    followUpQuestions: getFollowUpQuestionsForCategory("arbetsmiljo_2"),
    afsReferences: ["AFS 2023:3"]
  },
  {
    id: "arbetsmiljo_3",
    text: "Finns det risk för stress eller psykosocial ohälsa bland medarbetare?",
    kategori: "Arbetsmiljö",
    fas: "byggskede",
    followUpQuestions: [
      { id: "arbetsbelastning", text: "Är arbetsbelastningen för hög eller ojämnt fördelad?", category: "Psykosocial" },
      { id: "kontroll_mojligheter", text: "Har medarbetarna tillräcklig kontroll över sitt arbete?", category: "Psykosocial" },
      { id: "social_stod", text: "Finns tillräckligt socialt stöd från kollegor och chefer?", category: "Psykosocial" }
    ],
    afsReferences: ["AFS 2023:4"]
  },

  // Maskinsäkerhet
  {
    id: "maskiner_1",
    text: "Finns det säkerhetsrisker relaterade till maskiner och teknisk utrustning?",
    kategori: "Maskinsäkerhet",
    fas: "byggskede",
    followUpQuestions: getFollowUpQuestionsForCategory("maskiner_1"),
    afsReferences: ["AFS 2023:5"]
  },
  {
    id: "maskiner_2",
    text: "Kan nya maskiner eller förändringar av befintliga maskiner skapa säkerhetsrisker?",
    kategori: "Maskinsäkerhet",
    fas: "byggskede",
    followUpQuestions: [
      { id: "ce_markning", text: "Saknar maskiner CE-märkning eller säkerhetscertifiering?", category: "Certifiering" },
      { id: "underhall_rutiner", text: "Finns risk för otillräckligt underhåll av säkerhetssystem?", category: "Underhåll" },
      { id: "utbildning_personal", text: "Kan personal sakna utbildning för säker maskinanvändning?", category: "Utbildning" }
    ],
    afsReferences: ["AFS 2023:6"]
  },

  // Brandsäkerhet
  {
    id: "brand_1",
    text: "Finns det risker för brand eller explosion i verksamheten?",
    kategori: "Brandsäkerhet",
    fas: "byggskede",
    followUpQuestions: getFollowUpQuestionsForCategory("brand_1"),
    afsReferences: ["AFS 2023:7"]
  },
  {
    id: "brand_2",
    text: "Kan förändringar i verksamheten öka brandrisken?",
    kategori: "Brandsäkerhet",
    fas: "byggskede",
    followUpQuestions: [
      { id: "tändkällor", text: "Introduceras nya tändkällor i verksamheten?", category: "Tändkällor" },
      { id: "byggnadsmaterial", text: "Används brandfarliga byggnadsmaterial?", category: "Material" },
      { id: "automatisk_släckning", text: "Finns behov av automatiska släcksystem?", category: "Släcksystem" }
    ],
    afsReferences: ["AFS 2023:8"]
  },

  // Transport och logistik
  {
    id: "transport_1",
    text: "Finns det risker relaterade till transport och materialhantering?",
    kategori: "Transport",
    fas: "byggskede",
    followUpQuestions: getFollowUpQuestionsForCategory("transport_1"),
    afsReferences: ["AFS 2023:9"]
  },
  {
    id: "transport_2",
    text: "Kan förändringar i logistik eller transportflöden skapa nya risker?",
    kategori: "Transport",
    fas: "byggskede",
    followUpQuestions: [
      { id: "trafikintensitet", text: "Ökar trafikintensiteten betydligt i området?", category: "Trafik" },
      { id: "farligt_gods", text: "Transporteras farligt gods genom området?", category: "Farligt gods" },
      { id: "lossning_lastning", text: "Sker lastning/lossning under riskfyllda förhållanden?", category: "Lasthantering" }
    ],
    afsReferences: ["AFS 2023:10"]
  },

  // Miljörisker
  {
    id: "miljo_1", 
    text: "Finns det risker för miljöpåverkan från verksamheten?",
    kategori: "Miljö",
    fas: "bruksskede",
    followUpQuestions: getFollowUpQuestionsForCategory("miljo_1"),
    afsReferences: ["AFS 2023:11"]
  },
  {
    id: "miljo_2",
    text: "Kan verksamheten påverka omgivande naturmiljö eller bostadsområden?",
    kategori: "Miljö",
    fas: "bruksskede",
    followUpQuestions: [
      { id: "buller_omgivning", text: "Kan verksamheten orsaka störande buller för omgivningen?", category: "Buller" },
      { id: "markforor", text: "Finns risk för markförorening?", category: "Mark" },
      { id: "grundvatten", text: "Kan grundvattnet påverkas negativt?", category: "Vatten" }
    ],
    afsReferences: ["AFS 2023:12"]
  },

  // Informationssäkerhet
  {
    id: "informationssakerhet_1",
    text: "Finns det risker relaterade till informationssäkerhet och dataskydd?",
    kategori: "Informationssäkerhet",
    fas: "bruksskede",
    followUpQuestions: getFollowUpQuestionsForCategory("informationssakerhet_1"),
    afsReferences: ["AFS 2023:13"]
  },

  // Ekonomiska risker
  {
    id: "ekonomisk_1",
    text: "Finns det ekonomiska risker som kan påverka projektets genomförande?",
    kategori: "Ekonomi",
    fas: "byggskede",
    followUpQuestions: getFollowUpQuestionsForCategory("ekonomisk_1"),
    afsReferences: ["AFS 2023:14"]
  },

  // Juridiska risker
  {
    id: "juridisk_1",
    text: "Finns det juridiska risker eller regelverksförändringar som kan påverka verksamheten?",
    kategori: "Juridik",
    fas: "byggskede",
    followUpQuestions: getFollowUpQuestionsForCategory("juridisk_1"),
    afsReferences: ["AFS 2023:15"]
  },

  // Tekniska risker
  {
    id: "teknisk_1",
    text: "Finns det tekniska risker som kan påverka produktkvalitet eller systemfunktion?",
    kategori: "Teknik",
    fas: "bruksskede",
    followUpQuestions: getFollowUpQuestionsForCategory("teknisk_1"),
    afsReferences: ["AFS 2023:5", "AFS 2023:6"]
  },

  // Projektorganisationsrisker
  {
    id: "projektorganisation_1",
    text: "Finns det risker relaterade till projektorganisation och resursplanering?",
    kategori: "Projektorganisation",
    fas: "byggskede",
    followUpQuestions: getFollowUpQuestionsForCategory("projektorganisation_1"),
    afsReferences: ["AFS 2023:1"]
  },

  // Ytterligare specifika frågor
  {
    id: "leverantorskedja_1",
    text: "Finns det risker i leverantörskedjan som kan påverka verksamheten?",
    kategori: "Leverantörer",
    fas: "byggskede",
    followUpQuestions: [
      { id: "leverantorsutbildning", text: "Har leverantörer tillräcklig säkerhetsutbildning?", category: "Utbildning" },
      { id: "kvalitetssystem", text: "Har leverantörer dokumenterade kvalitetssystem?", category: "Kvalitet" },
      { id: "backup_leverantorer", text: "Finns backup-leverantörer för kritiska komponenter?", category: "Kontinuitet" }
    ],
    afsReferences: ["AFS 2023:2"]
  },

  {
    id: "noodplanering_1",
    text: "Finns det risker som kräver särskild nöd- och beredskapsplanering?",
    kategori: "Beredskap",
    fas: "byggskede",
    followUpQuestions: [
      { id: "larmsystem", text: "Finns fungerande larmsystem för olika typer av nödsituationer?", category: "Larm" },
      { id: "evakueringsplan", text: "Finns tydliga evakueringsplaner och utrymningsvägar?", category: "Evakuering" },
      { id: "forsta_hjalpen", text: "Finns tillräcklig första hjälpen-utrustning och utbildad personal?", category: "Första hjälpen" },
      { id: "krishantering", text: "Finns rutiner för krishantering och kommunikation?", category: "Krishantering" }
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:7"]
  }
];
